// extracted by mini-css-extract-plugin
module.exports = {"tip":"HowToPlay_tip__23M8k"};